// @todo проверить, нужен ли этот eslint-disable
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";

import styles from "./MocsowRegionDoctorPanel.style";
import {
  Button,
  Div,
  Panel,
  PanelHeader,
  ScreenSpinner,
  Select,
  Text,
} from "@vkontakte/vkui";
import Icon28ArrowLeftOutline from "@vkontakte/icons/dist/28/arrow_left_outline";
import { connect } from "react-redux";
import { setActivePanel, setPreviousPanel } from "../../redux/actions/panelsActions";
import { panels } from "../../variables";
import {
  selectRegion,
  startFourthStepLoading,
  moscowScenarioClearRegion,
} from "../../redux/actions/regionAndMedicalOrganisationActions";
import {
  checkRegionForBans,
  doctorSpecialitiesLoading,
  doctorSpecialitiesLoadingSuccess,
  loadDoctorNames,
  loadDoctorNamesSuccess,
  loadMedicalOrganisations,
  loadSlots,
  patientValidation,
  selectDoctorName,
  selectSpeciality,
  startOrderIdLoading,
} from "../../redux/actions/moscowScenarioActions";
import { getReadableDate } from "../../utils";
import { MOSCOW_SCENARIO_CLEAR_ERROR } from "../../redux/actions/types";

import CrossIcon from "../../img/IconColor.png";

const MoscowRegionDoctorPanel = ({
  id,
  moscowScenarioClearRegion,
  goBack,
  regions,
  selectedRegion,
  goToDefaultScenarioPage,
  selectRegion,
  checkRegionsForBans,
  bans,
  startOrderIdLoading,
  orderId,
  startPatientValidation,
  userInfo,
  patientId,
  startSpecialitiesLoading,
  showLoader,
  specialities,
  selectedSpeciality,
  selectSpeciality,
  loadDoctorNames,
  selectDoctorName,
  selectedDoctorName,
  doctorNames,
  clearDoctorNamesList,
  loadMedicalOrganisations,
  loadSlots,
  medicalOrganisation,
  slots,
  goToDatesPanel,
  clearSpecialitiesList,
  error,
  clearErrors,
}) => {
  useEffect(() => {
    checkRegionsForBans(selectedRegion.OKATO);
    selectSpeciality(null);
    clearDoctorNamesList();
    clearSpecialitiesList();
  }, []);

  useEffect(() => {
    if (bans === false) {
      startOrderIdLoading();
    }
  }, [bans]);

  useEffect(() => {
    if (orderId) {
      startPatientValidation(userInfo);
    }
  }, [orderId]);

  useEffect(() => {
    if (patientId) {
      startSpecialitiesLoading(userInfo, orderId);
      clearDoctorNamesList();
    }
  }, [patientId]);

  useEffect(() => {
    if (selectedSpeciality && !selectedDoctorName) {
      loadDoctorNames(selectedSpeciality, userInfo.sessionId, orderId);
    }
  }, [selectedSpeciality]);

  useEffect(() => {
    if (medicalOrganisation) {
      const firstDay = new Date();
      const lastDay = new Date(
        new Date(firstDay).getTime() + 1000 * 60 * 60 * 24 * 14
      );
      loadSlots(
        medicalOrganisation.MO_Id,
        userInfo.sessionId,
        selectedDoctorName.Resource_Id,
        getReadableDate(firstDay),
        getReadableDate(lastDay)
      );
    }
  }, [medicalOrganisation]);

  const onSelectChange = (event) => {
    let reg = null;
    let regKey = event.target.value;
    if (regions.length) {
      regions.forEach((item) => {
        if (item.regionCode === regKey) {
          reg = item;
        }
      });
    }
    if (regKey !== "77") {
      selectRegion(reg);
      goToDefaultScenarioPage();
      startFourthStepLoading(reg.OKATO);
    }
  };

  const mapSpecialityToOption = (speciality) => {
    return (
      <option key={speciality.Service_Id} value={JSON.stringify(speciality)}>
        {speciality.Service_Name}
      </option>
    );
  };

  const mapDoctorNameToOption = (doctorName) => {
    return (
      <option key={doctorName.Resource_Id} value={JSON.stringify(doctorName)}>
        {doctorName.Resource_Name}
      </option>
    );
  };
  return (
    <Panel id={id}>
      <PanelHeader
        left={
          <Div
            style={{
              margin: "0",
              padding: "0",
              display: "flex",
              justifyContent: "left",
            }}
          >
            <Icon28ArrowLeftOutline
              style={{
                paddingLeft: "6px",
              }}
              onClick={() => {
                goBack();
                clearErrors();
              }}
              fill={"#06844D"}
            />
            <Text
              style={{
                ...styles.headerText,
              }}
            >
              Запись к врачу
            </Text>
          </Div>
        }
        separator={false}
      ></PanelHeader>
      <Div
        style={{
          padding: "0",
          margin: "0",
          ...styles.wrapper,
        }}
      >
        <Text weight="regular" style={styles.selectorLabel}>
          Регион
        </Text>
        <Div style={styles.wrapperSelectRegion}>
          <Select
            placeholder={selectedRegion ? selectedRegion.name : "Не выбрано"}
            defaultValue={selectedRegion ? selectedRegion.regionCode : null}
            value={selectedRegion ? selectedRegion.regionCode : null}
            onChange={onSelectChange}
          >
            {regions.map((region) => (
              <option key={region.regionCode} value={region.regionCode}>
                {region.name}
              </option>
            ))}
          </Select>
          {selectedRegion ? (
            <img
              src={CrossIcon}
              onClick={() => {
                moscowScenarioClearRegion();
                goToDefaultScenarioPage();
              }}
              style={styles.imgClose}
              alt=""
            />
          ) : (
            ""
          )}
        </Div>
        {error ? (
          <Text style={styles.errorMessage}>{error.message}</Text>
        ) : showLoader ? (
          <Div style={styles.spinner}>
            <ScreenSpinner />{" "}
          </Div>
        ) : bans ? (
          <>
            <Text>Запись к врачу не доступна для данного региона</Text>
          </>
        ) : (
          <>
            <Text
              weight="regular"
              style={{
                ...styles.selectorLabel,
                marginTop: "26px",
              }}
            >
              Специальность врача
            </Text>
            <Select
              style={{ marginLeft: "1.33vw" }}
              placeholder={"Выберите специальность"}
              defaultValue={
                selectedSpeciality ? selectedSpeciality.Service_Name : undefined
              }
              value={
                selectedSpeciality ? JSON.stringify(selectedSpeciality) : undefined
              }
              onChange={(e) => {
                try {
                  clearDoctorNamesList();
                  selectSpeciality(JSON.parse(e.target.value));
                  selectDoctorName(null);
                } catch (e) {
                  selectSpeciality(null);
                  selectDoctorName(null);
                }
              }}
            >
              {specialities ? specialities.map(mapSpecialityToOption) : null}
            </Select>
            <Text weight="regular" style={styles.selectorWarningMessage}>
              Если вы не нашли врача нужной вам специальности, то запись к нему
              возможна только по направлению.{" "}
            </Text>
            <Text weight="regular" style={styles.selectorLabel}>
              Специалист
            </Text>
            <Select
              style={{ marginLeft: "1.33vw" }}
              placeholder={"Выберите специалиста"}
              defaultValue={
                selectedDoctorName ? selectedDoctorName.Resource_Name : undefined
              }
              value={
                selectedDoctorName ? JSON.stringify(selectedDoctorName) : undefined
              }
              onChange={(e) => {
                try {
                  selectDoctorName(JSON.parse(e.target.value));
                  loadMedicalOrganisations(
                    userInfo.sessionId,
                    JSON.parse(e.target.value),
                    orderId
                  );
                } catch (e) {
                  selectDoctorName(null);
                }
              }}
            >
              {doctorNames ? doctorNames.map(mapDoctorNameToOption) : null}
            </Select>
            <Button
              disabled={!selectedDoctorName || !slots}
              style={{ ...styles.nextButton, marginLeft: "1.33vw" }}
              onClick={() => goToDatesPanel()}
            >
              Далее
            </Button>
          </>
        )}
      </Div>
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    regions: state.regionAndMedicalOrganisation.regions,
    selectedRegion: state.regionAndMedicalOrganisation.selectedRegion,
    bans: state.moscowScenario.bans,
    orderId: state.moscowScenario.orderId,
    userInfo: state.userInfo.userInfo,
    patientId: state.moscowScenario.patientId,
    showLoader: state.loader.showMoscowScenarioLoader,
    specialities: state.moscowScenario.specialities,
    selectedSpeciality: state.moscowScenario.selectedSpeciality,
    doctorNames: state.moscowScenario.doctorNames,
    selectedDoctorName: state.moscowScenario.selectedDoctorName,
    medicalOrganisation: state.moscowScenario.medicalOrganisation,
    slots: state.dates.slots,
    error: state.moscowScenario.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    moscowScenarioClearRegion: () => dispatch(moscowScenarioClearRegion()),
    goBack: () => dispatch(setPreviousPanel()),
    goToDefaultScenarioPage: () =>
      dispatch(setActivePanel(panels.regionAndMedicalOrganisation)),
    selectRegion: (...args) => dispatch(selectRegion(...args)),
    startFourthStepLoading: (...args) =>
      dispatch(startFourthStepLoading(...args)),
    checkRegionsForBans: (...args) => dispatch(checkRegionForBans(...args)),
    startOrderIdLoading: () => dispatch(startOrderIdLoading()),
    startPatientValidation: (...args) => dispatch(patientValidation(...args)),
    startSpecialitiesLoading: (...args) =>
      dispatch(doctorSpecialitiesLoading(...args)),
    selectSpeciality: (...args) => dispatch(selectSpeciality(...args)),
    loadDoctorNames: (...args) => dispatch(loadDoctorNames(...args)),
    selectDoctorName: (...args) => dispatch(selectDoctorName(...args)),
    clearDoctorNamesList: () => dispatch(loadDoctorNamesSuccess(null)),
    clearSpecialitiesList: () =>
      dispatch(doctorSpecialitiesLoadingSuccess(null)),
    loadMedicalOrganisations: (...args) =>
      dispatch(loadMedicalOrganisations(...args)),
    loadSlots: (...args) => dispatch(loadSlots(...args)),
    goToDatesPanel: () => dispatch(setActivePanel(panels.choseDate)),
    clearErrors: () =>
      dispatch({
        type: MOSCOW_SCENARIO_CLEAR_ERROR,
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MoscowRegionDoctorPanel);
